let tempRecaptchKey = "6LcAw4ImAAAAAOFwkeAOfqmx8xFluzsHM2ETdGNB";
let tempClientKey = "220820702523-shjgukp5vtdk2mf3nujn56l6akb72rq9.apps.googleusercontent.com";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  console.log("dev");
} else {
  tempRecaptchKey = "6LcAw4ImAAAAAOFwkeAOfqmx8xFluzsHM2ETdGNB";
  tempClientKey = "220820702523-shjgukp5vtdk2mf3nujn56l6akb72rq9.apps.googleusercontent.com";
  // tempRecaptchKey = "6Lcodj8mAAAAABa5g7ONaW_qdZMHIfUpc-EacGXQ";
}

export let recaptchKey = tempRecaptchKey;
export let clientId = tempClientKey;
